import axios from "axios";
import store from "cache/store";
import { logout } from "features/authSlice";
const axiosClient = axios.create({
	baseURL: process.env.REACT_APP_BASE_API,
});

axiosClient.interceptors.request.use(
	(config) => {
		const { token } = store.getState().auth;

		if (token) {
			(config.headers as any)["Authorization"] = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Add a response interceptor
axiosClient.interceptors.response.use(
	(response) => {
		const {
			data: { code },
		} = response;
		//data no ok
		if (code !== 200) {
			//token expired or token invalid
			if (code === 401) {
				store.dispatch(logout());
			}
		}
		return response;
	},
	(error) => {
		console.log(error);
		const { data } = error.response;
		return Promise.reject(data);
	}
);

export default axiosClient;
